<script>
  import * as d3 from 'd3';

  import { formatEther } from 'viem';

  import { chainSymbol } from '../../stores.js';

  import Address from '../address.svelte';

  export let data;
  export let columns;
  export let colorFunc = undefined;

  const color = colorFunc || ((key, data, item) => d3.scaleOrdinal()
      .domain(data.map(d => d[key]))
      .range(d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), data.length).reverse())(item));
</script>

<table class="table">
  <tbody>
    {#each data as item}
      <tr>
        {#each columns as column}
          <td>
            {#if column.type === 'color'}
              <div class="rounded-lg w-6" style="background-color: { color(column.key, data, item[column.key]) };">
                &nbsp;
              </div>
            {:else if column.type === 'wallet'}
              <Address address={ item[column.key] } compact={ column.compact } type={ column.addressType } copiable={ column.copiable }>
                <svelte:fragment slot="copiable"><slot name="copiable" /></svelte:fragment>
              </Address>
            {:else if column.type === 'native'}
              <span class="amount">{ item[column.key] }</span><span class="symbol">{ $chainSymbol }</span>
            {:else if column.type === 'nativeEther'}
              <span class="amount">
                { new Intl.NumberFormat('default', { maximumSignificantDigits: 6 }).format(formatEther(item[column.key])) }
              </span>
              <span class="symbol">{ $chainSymbol }</span>
            {:else}
              { item[column.key] }
            {/if}
          </td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>